

/*
    creates two instances to handle
     - session storage
     - local storage
    please note: storage is an HTML5 feature, and might not be supported by some browsers
*/

const _hasStorage = () => typeof(Storage) !== 'undefined';

const _dummyStorage = {
  setItem: () => null,
  getItem: () => '',
  removeItem: () => null,
  clear: () => null
};

function getStorage(storage) {
  if(!_hasStorage || !storage) storage = _dummyStorage;

  const set = (key, value, expDays) => {
    if (expDays) {
      value = {
        data: value,
        expiry: Date.now() + expDays * 86400000 //24 * 60 * 60000;
      };
    }
    if(typeof value === 'object') {
      value = JSON.stringify(value);
    }
    try {
      storage.setItem(key, value);
    } catch(e) {
      //skip
    }
  };

  const get = (key, expDays) => {
    var value = null;
    try {
      value = storage.getItem(key);
      var parsedValue = JSON.parse(value);
      if (expDays && parsedValue) {
        if (isNaN(parsedValue.expiry) || parsedValue.expiry < Date.now()) {
          remove(key);
          return null;
        }
        return parsedValue.data;
      }
      if (typeof parsedValue !== 'object' && typeof parsedValue !== 'boolean') {
        return value;
      }
      return parsedValue;
    } catch (e) {
      if (expDays) {
        remove(key);
        return null;
      }
      return value;
    }
  };

  const remove = (key) => {
    try {
      storage.removeItem(key);
    } catch(e) {
      //skip
    }
  };

  const clearAll = () => {
    try {
      storage.clear();
    } catch(e) {
      //skip
    }
  };

  return {
    set, get, remove, clearAll
  };
}

const setLocalStorageWithTimeOut = (key, val, hours) => {
  var now = new Date().getTime();
  var setupTime = localStorage.getItem(`${key}_setupTime`);
  if (setupTime == null) {
      localStorage.setItem(key, JSON.stringify(val));
      localStorage.setItem(`${key}_setupTime`, now);
  } else {
      if(now-setupTime > 24*60*60*1000) {
          localStorage.removeItem(key);
          localStorage.removeItem(`${key}_setupTime`);
      }

      localStorage.setItem(key, JSON.stringify(val));
      localStorage.setItem(`${key}_setupTime`, now);
  }
}

const getLocalStorageWithTimeOut = (key, hours) => {
  var now = new Date().getTime();
  var setupTime = localStorage.getItem(`${key}_setupTime`);
  
  if(now-setupTime > 24*60*60*1000) {
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}_setupTime`);

      return false;
  } else {
      return localStorage.getItem(key) !== null ? JSON.parse(localStorage.getItem(key)) : false;
  }
}

const webStorage = {
  session: getStorage(typeof window !== 'undefined' && window.sessionStorage),
  local: getStorage(typeof window !== 'undefined' && window.localStorage),
};

export {getLocalStorageWithTimeOut, setLocalStorageWithTimeOut};
export default webStorage;